












































































































































































































































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import uuifComponent from '@/shared/uuifComponent';
import { currentUserKey } from '@/shared/msw-constants';
import { TableColumnConfig, TableEntry, ColumnSortRequestData, SortedColumnInfo, ColumnsAdjustRequestData, SwTable } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { CreateElement, VNode } from 'vue';
import { SwContentToolbar, SwContentToolbarExpand } from '@sonicwall/unified-ui-framework/src/shared/sw-content-toolbar';
import { SwExpandableTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { tooltip } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir';
// import _ from 'lodash';
import { SwIconButton } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-button';
import { SwDropMenu, DropMenuItem } from '@libs-uuif/shared/sw-drop-menu';
import { InfoState } from '@/core';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { MswAppTitle } from '@/shared/msw-app-title';
import orderConfirmed from '@/assets/images/order_confirmed.png';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { v4 as uuidv4 } from 'uuid';

const cssPrefix = 'service-coterm';
const cssPrefix2 = 'coterm-order-confirmation';

@Component({
  components: {
    ...uuifComponent,
    MswAppTitle,
    SwContentToolbar,
    SwContentToolbarExpand,
    SwExpandableTextfield,
    SwIconButton,
    SwCheckbox,
    SwDropMenu,
  },
  directives : {
    tooltip,
  },
})
export default class SnbServiceCoterm extends SwExtendedVue {
  cssPrefix =  cssPrefix;
  cssPrefix2 = cssPrefix2;
  orderConfirmed = orderConfirmed;
  cotermData : TableEntry[] = [];
  tempCotermdata : TableEntry[] = [];
  updatedCoTermData : TableEntry[] = [];
  showUpdatedCotermData : boolean = false;
  expandVisible : boolean = false;
  globalSearchValue : string = '';
  columnSearchValue : string = '';
  isExpandSearchFilter: boolean = false;
  termAndCondition : boolean =  false;
  isCotermComplete : boolean = false;
  selectedCotermRows : any[] = [];
  sortedColumns: SortedColumnInfo[] = [];
  eorderid: string = '';
  tableLoader: boolean = false;

  menuOpened: boolean = false;
  textExpanded: boolean = false;
  filterSearch: string = '';
  searchInputChips: any[] = [];
  filterSearchConfig: any = {
    isEnableFilterSearch: false,
    filterSearchKey:'',
    filterSearchOption:'',
    filterSearchLabel:'',
  };
  adjustedColumns: ColumnsAdjustRequestData = {};
  filterColumnKey: string = '';
  filterColumnValue: string = '';

   // For Filter menu items
  get filterItems(): DropMenuItem[] {
    return [
      {
        id: 'serialNumber',
        content: this.$t('products.serialnumber')
        .toString(),
      },
      {
        id: 'friendlyName',
        content: this.$t('products.friendlyName')
        .toString(),
      },
      {
        id: 'productLine',
        content: this.$t('products.productline')
        .toString(),
      },
      {
        id: 'productGroup',
        content: this.$t('products.tenantname')
        .toString(),
      },
      {
        id: 'serviceFamily',
        content: this.$t('products.servicename')
        .toString(),
      },
      {
        id: 'expDate',
        content: this.$t('bulkact.expir')
        .toString(),
      },
      {
        id: 'daysToleft',
        content: this.$t('home.days')
        .toString(),
      },
    ];
  }

  get cotermTableConfig() : TableColumnConfig[] {
    return [{
      key: 'selection',
      type: 'selection',
    },
    {
      key: '_key',
      dataKey: 'index',
      title: '#',
      width: 60,
    },
    {
      key : 'serialNumber',
      dataKey :  'serialNumber',
      title : this.$t('products.serialnumber')
      .toString(),
      sorter: (a: TableEntry, b: TableEntry) => {
        return  (a.serialNumber || '')
        .localeCompare(b.serialNumber || '', undefined, {
          numeric: true,
        });
      },
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
        {
          return (
            <div
              style={{ display: 'flex', flex: '1', alignItems: 'center' }}
              on-mouseover={() => {
                this.filterColumnKey = data.entry._key;
                this.filterColumnValue = data.entry.serialNumber;
              }}
              on-mouseleave={() => (this.filterColumnKey = '')}
            >
              { data.entry.serialNumber }
              {this.filterColumnKey === data.entry._key &&
                this.filterColumnValue === data.entry.serialNumber && (
                  <SwIcon
                    name="filter"
                    size={12}
                    style={{ marginLeft: '5px' }}
                    v-tooltip={{ content: 'Add Filter', compact: true, placement: 'bottom' }}
                    nativeOn-click={() => {
                      this.columnSearchValue = data.entry.serialNumber;
                      this.filterByEachRow('serialNumber');
                    }}
                  ></SwIcon>
                )}
            </div>
          ) as VNode;
        }
      },
    },
    {
      key : 'friendlyName',
      dataKey : 'friendlyName',
      title : this.$t('products.friendlyName')
      .toString(),
      sorter: (a: TableEntry, b: TableEntry) => {
        return  (a.friendlyName || '')
        .localeCompare(b.friendlyName || '', undefined, {
          numeric: true,
        });
      },
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
        {
          return (
            <div
              style={{ display: 'flex', flex: '1', alignItems: 'center' }}
              on-mouseover={() => {
                this.filterColumnKey = data.entry._key;
                this.filterColumnValue = data.entry.friendlyName;
              }}
              on-mouseleave={() => (this.filterColumnKey = '')}
            >
              { data.entry.friendlyName }
              {this.filterColumnKey === data.entry._key &&
                this.filterColumnValue === data.entry.friendlyName && (
                  <SwIcon
                    name="filter"
                    size={12}
                    style={{ marginLeft: '5px' }}
                    v-tooltip={{ content: 'Add Filter', compact: true, placement: 'bottom' }}
                    nativeOn-click={() => {
                      this.columnSearchValue = data.entry.friendlyName;
                      this.filterByEachRow('friendlyName');
                    }}
                  ></SwIcon>
                )}
            </div>
          ) as VNode;
        }
      },
    },
    {
      key : 'productLine',
      title : this.$t('products.productline')
      .toString(),
      sorter: (a: TableEntry, b: TableEntry) => {
        return  (a.productLine || '')
        .localeCompare(b.productLine || '', undefined, {
          numeric: true,
        });
      },
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
        {
          return (
            <div
              style={{ display: 'flex', flex: '1', alignItems: 'center' }}
              on-mouseover={() => {
                this.filterColumnKey = data.entry._key;
                this.filterColumnValue = data.entry.productLine;
              }}
              on-mouseleave={() => (this.filterColumnKey = '')}
            >
              <div domPropsInnerHTML={data.entry.productLine}>
              </div>
              {this.filterColumnKey === data.entry._key &&
                this.filterColumnValue === data.entry.productLine && (
                  <SwIcon
                    name="filter"
                    size={12}
                    style={{ marginLeft: '5px' }}
                    v-tooltip={{ content: 'Add Filter', compact: true, placement: 'bottom' }}
                    nativeOn-click={() => {
                      this.columnSearchValue = data.entry.productLine;
                      this.filterByEachRow('productLine');
                    }}
                  ></SwIcon>
                )}
            </div>
          ) as VNode;
        }
      },
    },
    {
      key : 'productGroup',
      dataKey : 'productGroup',
      title : this.$t('products.tenantname')
      .toString(),
      sorter: (a: TableEntry, b: TableEntry) => {
        return  (a.productGroup || '')
        .localeCompare(b.productGroup || '', undefined, {
          numeric: true,
        });
      },
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
        {
          return (
            <div
              style={{ display: 'flex', flex: '1', alignItems: 'center' }}
              on-mouseover={() => {
                this.filterColumnKey = data.entry._key;
                this.filterColumnValue = data.entry.productGroup;
              }}
              on-mouseleave={() => (this.filterColumnKey = '')}
            >
              <div domPropsInnerHTML={data.entry.productGroup}>
              </div>
              {this.filterColumnKey === data.entry._key &&
                this.filterColumnValue === data.entry.productGroup && (
                  <SwIcon
                    name="filter"
                    size={12}
                    style={{ marginLeft: '5px' }}
                    v-tooltip={{ content: 'Add Filter', compact: true, placement: 'bottom' }}
                    nativeOn-click={() => {
                      this.columnSearchValue = data.entry.productGroup;
                      this.filterByEachRow('productGroup');
                    }}
                  ></SwIcon>
                )}
            </div>
          ) as VNode;
        }
      },
    },
    {
      key  : 'serviceFamily',
      dataKey : 'serviceFamily',
      title : this.$t('products.servicename')
      .toString(),
      sorter: (a: TableEntry, b: TableEntry) => {
        return  (a.serviceFamily || '')
        .localeCompare(b.serviceFamily || '', undefined, {
          numeric: true,
        });
      },
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
        {
          return (
            <div
              style={{ display: 'flex', flex: '1', alignItems: 'center' }}
              on-mouseover={() => {
                this.filterColumnKey = data.entry._key;
                this.filterColumnValue = data.entry.serviceFamily;
              }}
              on-mouseleave={() => (this.filterColumnKey = '')}
            >
              <div domPropsInnerHTML={data.entry.serviceFamily}>
              </div>
              {this.filterColumnKey === data.entry._key &&
                this.filterColumnValue === data.entry.serviceFamily && (
                  <SwIcon
                    name="filter"
                    size={12}
                    style={{ marginLeft: '5px' }}
                    v-tooltip={{ content: 'Add Filter', compact: true, placement: 'bottom' }}
                    nativeOn-click={() => {
                      this.columnSearchValue = data.entry.serviceFamily;
                      this.filterByEachRow('serviceFamily');
                    }}
                  ></SwIcon>
                )}
            </div>
          ) as VNode;
        }
      },
    },
    {
      key : 'expDate',
      dataKey : 'dtExpDate',
      title : this.$t('bulkact.expir')
      .toString(),
      sorter: ((a: any, b: any) => {
        const aExpDate: any = new Date(a.expDate);
        const bExpDate: any = new Date(b.expDate);
        return aExpDate - bExpDate;
      }),
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
        {
          return (
            <div
              style={{ display: 'flex', flex: '1', alignItems: 'center' }}
              on-mouseover={() => {
                this.filterColumnKey = data.entry._key;
                this.filterColumnValue = data.entry.expDate;
              }}
              on-mouseleave={() => (this.filterColumnKey = '')}
            >
              <div domPropsInnerHTML={data.entry.expDate}>
              </div>
              {this.filterColumnKey === data.entry._key &&
                this.filterColumnValue === data.entry.expDate && (
                  <SwIcon
                    name="filter"
                    size={12}
                    style={{ marginLeft: '5px' }}
                    v-tooltip={{ content: 'Add Filter', compact: true, placement: 'bottom' }}
                    nativeOn-click={() => {
                      this.columnSearchValue = data.entry.expDate;
                      this.filterByEachRow('expDate');
                    }}
                  ></SwIcon>
                )}
            </div>
          ) as VNode;
        }
      },
    },
    {
      key : 'daysToleft',
      dataKey : 'daysToleft',
      title : this.$t('home.days')
      .toString(),
      sorter: (a: TableEntry, b: TableEntry) => {
        return  (a.daysToleft || '')
        .localeCompare(b.daysToleft || '', undefined, {
          numeric: true,
        });
      },
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
        {
          return (
            <div
              style={{ display: 'flex', flex: '1', alignItems: 'center' }}
              on-mouseover={() => {
                this.filterColumnKey = data.entry._key;
                this.filterColumnValue = data.entry.daysToleft;
              }}
              on-mouseleave={() => (this.filterColumnKey = '')}
            >
              <div domPropsInnerHTML={data.entry.daysToleft}>
              </div>
              {this.filterColumnKey === data.entry._key &&
                this.filterColumnValue === data.entry.daysToleft && (
                  <SwIcon
                    name="filter"
                    size={12}
                    style={{ marginLeft: '5px' }}
                    v-tooltip={{ content: 'Add Filter', compact: true, placement: 'bottom' }}
                    nativeOn-click={() => {
                      this.columnSearchValue = data.entry.daysToleft;
                      this.filterByEachRow('daysToleft');
                    }}
                  ></SwIcon>
                )}
            </div>
          ) as VNode;
        }
      },
    }];
  }

  get updatedCotermTableConfig() : TableColumnConfig[] {
    return [{
      key: 'index',
      type: 'index',
    },
    {
      key : 'serialNumber',
      dataKey :  'serialNumber',
      title : this.$t('products.serialnumber')
      .toString(),
    },
    {
      key : 'productLine',
      title : this.$t('products.productline')
      .toString(),
      render : (h : CreateElement, data) : VNode => { // tslint:disable-line
        return (
            <div domPropsInnerHTML={data.entry.productLine}>
            </div>
        ) as VNode;
      },
    },
    {
      key  : 'serviceFamily',
      dataKey : 'serviceFamily',
      title : this.$t('products.servicename')
      .toString(),
    },
    {
      key : 'expDate',
      dataKey : 'expDate',
      title : this.$t('bulkact.expir')
      .toString(),
    },
    {
      key : 'cotermDate',
      dataKey : 'cotermDate',
      title : this.$t('nfr.cotermdt')
      .toString(),
    }];
  }

  get tableData() {
    return this.cotermData;
  }

  onRequestAdjustColumns(data: ColumnsAdjustRequestData) {
    this.adjustedColumns = data;
  }

  created() {
    this.getCotermData();
  }

  getCotermData() {
    this.onRemoveAllFilters();
    this.clearSelectedRows();
    this.tableLoader = true;
    this.$store.dispatch('SnbCoTermStoreModule/getCotermData', JSON.parse(localStorage.getItem(currentUserKey) as any).userId)
    .then((response : any) => {
      if (response.content.records) {
        const rowData = response.content.records;
        this.cotermData = rowData?.map((ele : any, index: number) => {
          ele._key = `${uuidv4()}`;
          ele.index = index + 1;
          ele._selectable = true;
          return ele;
        });
        this.tempCotermdata = [...this.cotermData];
      } else {
      }
      this.$store.commit('stopLoading');
    })
    .finally(() => {
      this.tableLoader = false;
    });
  }

  onToggleFilterExpand() {
    this.expandVisible = !this.expandVisible;
  }

  onSelectMultiItem(type: any) {
    this.menuOpened = !this.menuOpened;
    this.globalSearchValue = '';
    const isExistingChip = this.searchInputChips?.find((el: any) => el.column === type);
    if (!isExistingChip) {
      this.filterSearchConfig.isEnableFilterSearch = true;
      this.filterSearchConfig.filterSearchOption = type;
      this.filterSearchConfig.filterSearchLabel = this.filterItems.filter(ele => ele.id.toString() === type)[0].content;
    }
  }

  filterByEachRow(type: any) {
    this.globalSearchValue = '';
    if (this.columnSearchValue) {
      const isExistingChip = this.searchInputChips?.find((el: any) => el.column === type);
      if (!isExistingChip) {
        this.searchInputChips.push({ value: this.columnSearchValue.trim(), column: type });
      }
      this.applyAllFilters();
    }
  }

  handleSearchFilter() {
    this.expandVisible = !this.expandVisible;
    this.applyAllFilters();
  }

  clearSearchFilter() : void {
    this.textExpanded = !this.textExpanded;
    this.globalSearchValue = '';
    this.applyAllFilters();
  }

  removeInputChip(index: any) {
    this.searchInputChips.splice(index, 1);
    this.applyAllFilters();
  }

  addFilterKey(event: any) {
    if (event.code === 'Enter' && this.filterSearchConfig.filterSearchKey !== '') {
      this.searchInputChips.push({ label:this.filterSearchConfig.filterSearchLabel, value: this.filterSearchConfig.filterSearchKey.trim(), column: this.filterSearchConfig.filterSearchOption });
      this.applyAllFilters();
      this.filterSearchConfig.filterSearchKey = '';
      this.filterSearchConfig.filterSearchLabel = '';
      this.filterSearchConfig.isEnableFilterSearch = false;
    }
  }

  applyAllFilters() {
    const data: any[] = [...this.tempCotermdata];
    let filteredData : any[] = [];
    this.$store.commit('startLoading');
    if (this.globalSearchValue) {
      const key : string = this.globalSearchValue.toUpperCase();
      let flag : number = 0;
      const searchKeys = ['serialNumber', 'friendlyName', 'productLine', 'productGroup', 'serviceFamily', 'expDate', 'daysToleft'];
      filteredData = this.tempCotermdata.filter((item : any) => {
        flag = 0;
        searchKeys.forEach((field) => {
          if (item[field] && (item[field].toUpperCase()).indexOf(key) >= 0) {
            flag = 1;
            return false;
          }
          if (item[field] && (item[field].toUpperCase()).indexOf(key) < 0) {
            return true;
          }
        });
        if (flag === 1) {
          return true;
        }
      });
    } else {
      if (this.searchInputChips.length === 0) {
        this.cotermData = data;
        this.reSelectRows();
        this.$store.commit('stopLoading');
        return;
      }
      filteredData = data.filter((item:any) => {
        item.productLine = item.productLine
          .includes('<span style=\"vertical-align: sub;font-style: italic;\">') ? item.productLine
          .replace('<span style=\"vertical-align: sub;font-style: italic;\">', '') : item.productLine;
        item.productLine = item.productLine
          .includes('</span>') ? item.productLine
          .replace('</span>', '') : item.productLine;
        for (const filter of this.searchInputChips) {
          if (!item[filter.column].toLowerCase()
          .includes(filter.value.toLowerCase())) {
            return false;
          }
        }
        return true;
      });
    }
    this.cotermData = [...filteredData];
    this.$store.commit('stopLoading');
  }

  onRemoveAllFilters() {
    this.globalSearchValue = '';
    this.columnSearchValue = '';
    this.filterSearchConfig = {
      isEnableFilterSearch: false,
      filterSearchKey:'',
      filterSearchOption:'',
      filterSearchLabel:'',
    };
    this.searchInputChips = [];
    this.applyAllFilters();
  }
  // Filter Implementation ends

  onEntrySelecting(event : any) {
    if (event.selecting) {
      const index = this.cotermData.findIndex((ele : any) => {
        return ele._key === event.entryKey;
      });
      if (this.cotermData[index] === undefined) {
        this.selectedCotermRows.push({ entryKey : event.entryKey, data : this.tempCotermdata[index] });
      } else {
        this.selectedCotermRows.push({ entryKey : event.entryKey, data : this.cotermData[index] });
      }
    } else if (!event.selecting && this.getConditionForDeselect(event)) {
      const index = this.selectedCotermRows.findIndex((ele : any) => {
        return ele.entryKey === event.entryKey;
      });
      if (index > -1) {
        this.selectedCotermRows.splice(index, 1);
      }
    }
  }

  reSelectRows() {
    const vm = this.$refs.cotermTable as SwTable;
    if (vm) {
      const tempSet: any = new Set();
      this.selectedCotermRows.forEach((ele: any) => tempSet.add(ele.entryKey));
      vm.selectedSet = tempSet;
      this.selectedCotermRows.forEach((row: any) => {
        const filteredData = this.tempCotermdata.filter((ele: any) => ele._key === row.entryKey);
        vm.claimEntrySelected(filteredData[0], true, true);
      });
    }
  }

  getConditionForDeselect(data: any) {
    let val = false;
    let dataPresenetInSelectedRow: boolean = false;
    if (this.searchInputChips.length > 0 || this.globalSearchValue.length > 0) {
      this.cotermData.forEach((ele: any) => {
        if (ele._key === data.entryKey) {
          dataPresenetInSelectedRow = true;
        }
      });
    }
    if (this.searchInputChips.length === 0 && this.globalSearchValue.length === 0) {
      val = true;
    } else if ((this.searchInputChips.length > 0 || this.globalSearchValue.length > 0) && dataPresenetInSelectedRow) {
      val = true;
    }
    return val;
  }

  clearSelectedRows() {
    this.selectedCotermRows = [];
    const vm = this.$refs.cotermTable as SwTable;
    if (vm) {
      vm.selectedSet.clear();
    }
    this.cotermData = this.cotermData.slice();
  }

  postforCoTermDate() {
    const req : any[] = [];
    this.selectedCotermRows.forEach((ele : any) => {
      const cotermObj =  { fieldValueid :  ele.data.fieldValueid, isChecked : 1 };
      req.push(cotermObj);
    });
    this.$store.dispatch('SnbCoTermStoreModule/postforCoTermDate', {
      request : {
        coTermList : req,
      },
      userName : JSON.parse(localStorage.getItem(currentUserKey) as any).userId,
    })
    .then((response : any) => {
      if (response.operationStatus === 'OK' && response.content.respList) {
        this.updatedCoTermData = response.content.respList.map((ele : any, index : any) => {
          ele._key = index.toString();
          return ele;
        });
        this.showUpdatedCotermData = true;
      } else {
        const message : InfoState = { infoType : 'failed', infoMsg : response.msgDesc };
        this.$store.commit('enqueueMessage', message);
      }
      this.$store.commit('stopLoading');
    });
  }

  backToCotermData() {
    this.showUpdatedCotermData = false;
    this.selectedCotermRows = [];
    this.onRemoveAllFilters();
  }

  completeUpdateCoterm() {
    this.$store.dispatch('SnbCoTermStoreModule/completeCoTerm', JSON.parse(localStorage.getItem(currentUserKey) as any).userId)
    .then((response : any) => {
      if (response?.operationStatus === 'OK') {
        this.showUpdatedCotermData = false;
        this.isCotermComplete = true;
        this.eorderid = response?.content?.eorderId;
        const message : InfoState = { infoType : 'success', infoMsg : '' };
        this.$store.commit('enqueueMessage', message);
      }
      this.$store.commit('stopLoading');
    });
  }

    // For ting the rows
  onRequestSorting(data: ColumnSortRequestData) {
    data.cancel = false;
    const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    if (index < 0) {
      if (data.cancel) { return; }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.ascending === undefined) {
        this.sortedColumns[index].ascending = !this.sortedColumns[index].ascending;
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }
}
